export const emails_to_send_crash_report =
  'kolawole@vpay.africa, admin@vpay.africa, chijindu@vpay.africa, frank@vpay.africa, kalu@vpay.africa, sakirat.usman@minerva.ng, joseph.chinemerem@minerva.ng, tochukwu.ali@minerva.ng';
